export class AssetCategoryActiveDeactiveModelDto {
    assetsCatagoryId:number;
    isActive?: boolean;
    updatedUser?: string;

    constructor(assetsCatagoryId:number, isActive?: boolean, updatedUser?: string) {
        this.assetsCatagoryId = assetsCatagoryId;
        this.isActive = isActive;
        this.updatedUser = updatedUser;
    }

}